var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganisations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Organisations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Organisations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#3D4A68",
    strokeWidth: 1.5,
    x: 5,
    y: 3,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#3D4A68",
    strokeWidth: 1.5,
    x: 8,
    y: 13,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 17,
    x2: 17,
    y2: 17,
    id: "Line-6",
    stroke: "#3D4A68",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 7,
    x2: 12,
    y2: 7,
    id: "Line-6",
    stroke: "#3D4A68",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 10,
    x2: 12,
    y2: 10,
    id: "Line-6",
    stroke: "#3D4A68",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisations);
export default __webpack_public_path__ + "static/media/organisations.0c966125625694f1d94e9bdfba5303bf.svg";
export { ForwardRef as ReactComponent };